import AWS from "aws-sdk";
import { Decryption } from "./common.service";

export const uploadImageOnAWS = async (file, folder) => {
  try {
    // Decrypt the credentials and set AWS config
    const credentials = await Decryption(localStorage.getItem("credential"));
    //console.log("Decrypted credentials:", credentials);

    // Dynamically set AWS config using decrypted credentials
    const config = {
      region: credentials.APP_AWS_S3_REGION_NAME,
      accessKeyId: credentials.APP_AWS_ACCESS_KEY_ID,
      secretAccessKey: credentials.APP_AWS_SECRET_ACCESS_KEY,
    };

    // Update AWS configuration
    AWS.config.update(config);
    //console.log("AWS Config Initialized Successfully");

    // Initialize S3 client with the updated config
    const s3 = new AWS.S3();
    //console.log("File", file);

    let extension = file.type?.split("/")[1];

    // Manually check for SVG files
    if (file.type === "image/svg+xml") {
      extension = "svg";
    } else {
      extension = "png";
    }

    const fileName = `${new Date().getTime()}.${extension}`;
    //console.log("File Name:", fileName);
    //console.log("File Extension:", extension);

    // Use the bucket name from the decrypted credentials
    const bucketName = credentials.AWS_STORAGE_BUCKET_NAME;
    if (!bucketName) {
      throw new Error("Bucket name is not available in the credentials.");
    }

    // Set parameters for S3 upload
    const params = {
      Bucket: bucketName, // Set the bucket dynamically from credentials
      Key: `${folder}/${fileName}`,
      Body: file,
      ACL: "public-read-write",
      ContentType: extension === "png" ? "image/png" : "image/svg+xml",
    };

    // Upload the file to S3
    const result = await s3.upload(params).promise();
   // console.log("File uploaded successfully:", result);
    return fileName;
  } catch (error) {
    console.error("Error during file upload:", error);
    throw error;
  }
};
